import React from 'react';
import { Circle } from '@chakra-ui/react';

interface DashedCircleProps {
	icon: React.ReactNode;
	size?: string;
}

/** A dashed-border circle avatar placeholder used when no photo/initials are available */
const DashedCircle: React.FC<DashedCircleProps> = ({ icon, size = '36px' }) => (
	<Circle
		size={size}
		borderWidth="1.5px"
		borderStyle="dashed"
		borderColor="border.default"
		bg="surface.default"
		color="fg.muted"
		flexShrink={0}
	>
		{icon}
	</Circle>
);

export default DashedCircle;
